// extracted by mini-css-extract-plugin
module.exports = {"prodTitle__featuredCard":"ob_J3AByy","prodTitle":"ob_BJNXYb","programNotAnnounced":"ob_PumkAQ"};